import React from 'react'

export const ListHeader = () => {
  return (
    <thead>
      <tr>
        <th style={{ width: '20px' }} />
        <th style={{ width: '32px' }} />
        <th>Name</th>
        <th style={{ width: '100px' }} />
      </tr>
    </thead>
  )
}
